module.exports = __webpack_public_path__ + "static/circle-fb03e1fcda573eac1745710547f50551.png";